
import Image from 'next/image';

const SocialItem = ({data}) => {
  const {social, url, icon} = data;
  const Icon = props => {
    switch (icon) {
      case 'phone':
        return <Image src='/svg/phone.svg' width={16} height={16} alt='' unoptimized />;
      case 'X':
        return <Image src='/img/logo-black.png' width={16} height={16} alt='' unoptimized />;
      case 'linkedin':
        return <Image src='/svg/inst.svg' width={16} height={16} alt='' unoptimized />;
      case 'youtube':
        return <Image src='/img/youtube.png' width={16} height={16} alt='' unoptimized />;

  }
}

  return <li className='social-item'>
    <a href={`${url}`} className={`social-link ${social}`}>
      <div className="social-img">
              <Icon />
      </div>
    </a>
  </li>;
};

export default SocialItem;

